export default "__VITE_ASSET__0b2ddb3b__"